<template>
	<div class="modal j-link-click-interception-popup j-popup">
		<div class="modal__card modal__card--micro modal__card--blank">
			<h3 class="modal__title modal__title--large mb-10 text-center">{{ $t('unload_page_popup.title') }}</h3>
			<p class="modal__text">
				{{ $t('unload_page_popup.text_1') }}
			</p>
			<p class="modal__text modal__text--large bold-font text-center mt-20">
				{{ $t('unload_page_popup.text_2') }}
			</p>
			<div class="text-center mt-10">
				<button class="regular-btn action-btn j-hide-popup">{{ $t('unload_page_popup.no') }}</button><br>
				<a :href="href" class="regular-btn white-btn j-link-click-interception-link mt-10">{{ $t('unload_page_popup.yes') }}</a>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'UnloadPagePopup',

	props: {
		current_company: ''
	},

	data() {
		return {
			href: '',
			timer: null,
			timeSpent: 0,
			threshold: 300000
		}
	},

	mounted() {
		this.startTimer();
		this.unloadPage();
	},

	methods: {
		startTimer() {
			this.timer = setInterval(() => {
				this.timeSpent += 1000;
				if (this.timeSpent >= this.threshold) {
					clearInterval(this.timer);
				}
			}, 1000);
		},

		unloadPage() {
			const links = document.querySelectorAll('.j-unload-page-link');

			links.forEach(link => {
				link.addEventListener('click', (e) => {
					if (this.timeSpent < this.threshold) {
						e.preventDefault();
						const href = e.currentTarget.getAttribute('href');
						show_popup('.j-link-click-interception-popup')
						document.querySelector('.j-link-click-interception-link').setAttribute('href', href)
					}
				});
			});
		}
	},

	beforeDestroy() {
		clearTimeout(this.timer);
	},
}
</script>
